import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createQueue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Queue.
 */
export const useCreateQueue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createQueue.
     * @param {Pella.ProductionRequestAPI.CreateQueueInput} input - The inputs for creating the Queue.
     */
    mutationFn: (input) => createQueue(input),
    onSuccess: () => {
      toast.success('Queue created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.QUEUE_DATA] });
    },
  });
};
